{
  "comment": "Mission 3, The Transferred Team (spec §6; S13 owns): a data-driven step machine (plan §2; the runtime is S6). Offered at tier 3 (the lab lead is always given at tier 3); the giver is Kell, or the Mutual Bulletin lead when Holdfast standing is below 0 (src/story/okafor.ts m3OfferContact). No step has a deadline. relay: the hideout lane is down (laneRepair, a story-owned job; the hideout is never a generic target before tier 3, W5). meet: dock at the hideout; Okafor's risk starts from the relay repair with the mission active (okafor.ts, online days only). trust: completes only through okafor.ts proveTrust (a recent meter reading of a Tethys operation, the player's tetherstone records or the Watch history; a mission rig is requested when no Tethys rig exists, T5); the target reply is never shown in the comms UI. lab: the sealed report core from his old lab (a story item); Voss hails once the core is aboard, with no offer. inspection: the Charter Patrol on the way out (comply logs the core: hale_aware). report: Okafor offers to testify, then asks to be left out: named or anonymous. Rewards: Holdfast standing; Okafor's meter calibration module is world content (S38). Fork costs are the text shown before commit. Site, station and node refs are story-site ids the story link resolves (S30).",
  "id": "m3",
  "offer": {
    "tier": 3,
    "contact": "kell",
    "comms": "m3.kell.offer"
  },
  "steps": [
    {
      "id": "relay",
      "verb": "laneRepair",
      "contractType": "laneRepair",
      "target": { "kind": "ring", "ref": "okafor-hideout" }
    },
    {
      "id": "meet",
      "verb": "dock",
      "target": { "kind": "station", "ref": "okafor-hideout" },
      "onDone": { "comms": "m3.okafor.meet" }
    },
    {
      "id": "trust",
      "verb": "comms",
      "target": { "kind": "reply", "ref": "m3.okafor.trust/proof" },
      "onDone": { "comms": "m3.okafor.reading" }
    },
    {
      "id": "lab",
      "verb": "recover",
      "target": { "kind": "poi", "ref": "okafor-lab" },
      "item": "report_core",
      "onDone": {
        "items": [{ "id": "report_core", "state": "held" }],
        "setFlags": ["report_original", "voss_contacted"],
        "comms": "m3.voss.contact"
      }
    },
    {
      "id": "inspection",
      "verb": "comms",
      "target": { "kind": "node", "ref": "m3.patrol.inspection" }
    },
    {
      "id": "report",
      "verb": "comms",
      "target": { "kind": "node", "ref": "m3.okafor.testify" },
      "onDone": { "standings": [{ "faction": "holdfast", "delta": 10 }] }
    }
  ],
  "forks": [
    {
      "id": "inspection",
      "afterStep": "inspection",
      "choices": [
        {
          "id": "comply",
          "cost": "Open the hold. The core goes in the Patrol's log, and the log goes to the Charter Office.",
          "outcome": { "setFlags": ["hale_aware"], "comms": "m3.patrol.logged" }
        },
        {
          "id": "evade",
          "cost": "Mask the hold and hope the scan misses it. If it doesn't, that's smuggling.",
          "outcome": { "comms": "m3.patrol.evade" }
        },
        {
          "id": "run",
          "cost": "Burn for the lane. Running from a Patrol cutter is a crime, and they'll have your registry.",
          "outcome": { "comms": "m3.patrol.run" }
        }
      ]
    },
    {
      "id": "okafor",
      "afterStep": "report",
      "choices": [
        {
          "id": "named",
          "cost": "His name on the record carries more weight. He comes with you, and Asset Recovery will know which ship he's on.",
          "outcome": { "setFlags": ["okafor_public"], "okaforState": "aboard", "comms": "m3.okafor.named" }
        },
        {
          "id": "anonymous",
          "cost": "An unnamed witness counts for less at a hearing. He stays hidden, and safe.",
          "outcome": { "setFlags": ["okafor_anonymous"], "okaforState": "safe", "comms": "m3.okafor.anonymous" }
        }
      ]
    }
  ],
  "trace": "okafor-relay-open"
}
